//# Auth Constants
export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_VALIDATE = 'AUTH_VALIDATE'
